const StandaloneAppConfig = {
  AUTH_TOKEN_FIELD: 'authToken',
  USER_FIELD: 'user',
  ORIGIN_FIELD: 'origin',
};

const SubAppConfig = {
  AUTH_TOKEN_FIELD: 'omni_auth_token',
  USER_FIELD: 'omni_user_data',
  ORIGIN_FIELD: 'omni_origin',
};

let config = StandaloneAppConfig;

const setIsSubApp = (isSubApp) => {
  config = isSubApp ? SubAppConfig : StandaloneAppConfig;
};

const getToken = () => localStorage.getItem(config.AUTH_TOKEN_FIELD);
const setToken = (token) =>
  localStorage.setItem(config.AUTH_TOKEN_FIELD, token);
const removeToken = () => localStorage.removeItem(config.AUTH_TOKEN_FIELD);

const getUser = () => {
  try {
    return JSON.parse(localStorage.getItem(config.USER_FIELD));
  } catch (e) {
    return null;
  }
};
const setUser = (user) => {
  const payload = typeof user === 'string' ? user : JSON.stringify(user);

  localStorage.setItem(config.USER_FIELD, payload);
};
const removeUser = () => localStorage.removeItem(config.USER_FIELD);

const getOrigin = () => localStorage.getItem(config.ORIGIN_FIELD);
const setOrigin = (origin) => localStorage.setItem(config.ORIGIN_FIELD, origin);
const removeOrigin = () => localStorage.removeItem(config.ORIGIN_FIELD);

export const LocalStorage = {
  getToken,
  setToken,
  removeToken,
  getUser,
  setUser,
  removeUser,
  getOrigin,
  setOrigin,
  removeOrigin,
  setIsSubApp,
};
